"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractEnrichCase = void 0;
class AbstractEnrichCase {
    constructor(semantic) {
        this.semantic = semantic;
    }
}
exports.AbstractEnrichCase = AbstractEnrichCase;
